/* eslint-disable react/prop-types */

import React, { Fragment } from 'react';
import ResultLinks from './ResultLinks';
import ResultSelect from './ResultSelect';
import ResultMedia from './ResultMedia';
import FieldDisplay from '../../field/display/FieldDisplay';

const DefaultResults = (props) => {
  const {objects, displayLink, addToCart,removeFromCart, addLink, selectable, defaultImage, canLinkMultipleObjects, isPublicUser} = props;
  let loadedImageCount = 0;
  const displayedObjectsCount = objects.length;

  const imageLoadedCallback = () => {
    loadedImageCount++;
    if (loadedImageCount >= displayedObjectsCount) {
      window.parent?.resizeIframe();
    }
  };

  return (
    <Fragment>
      {
        objects.map((object, index) => (
          <div key={index} className={index % 2 === 0 ? 'shaded' : ''}>
            <DefaultResult
              object={object}
              displayLink={displayLink}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              addLink={addLink}
              selectable={selectable}
              defaultImage={defaultImage}
              isPublicUser={isPublicUser}
              canLinkMultipleObjects={canLinkMultipleObjects}
              imageLoadedCallback={imageLoadedCallback}
            />
          </div>
        ))
      }
    </Fragment>
  );
};

export const DefaultResult = props => {
  const {object, selectable, defaultImage, addLink, canLinkMultipleObjects, imageLoadedCallback} = props;
  let projection = 'NONE';
  object.fields.forEach(field => {
    if(field.predicate === 'http://www.profium.com/spectrum/objectType' && field.values[0] === '360-video'){
      projection = '360';
    }
  });

  return (
    <table className="result-pane result-pane--default">
      <tbody>
        <tr>
          <td className="result-pane__action-image">
            <div className="result-pane__action">
              <ResultSelect selectable={(selectable && !addLink) || canLinkMultipleObjects} object={object} projection={projection}/>
            </div>
            <div className="result-pane__image">
              <span className="resultEntryDisplayImageView">
                <ResultMedia image={object.image} defaultImage={defaultImage} projection={projection} onImageLoad={imageLoadedCallback} />
              </span>
            </div>
          </td>
          <td className="result-pane__info">
            {
              object.fields.map((field, index) => (
                <FieldDisplay field={field} key={index} />
              ))
            }
            <ResultLinks {...props} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};



export default DefaultResults;